/* unplugin-vue-components disabled */import { render } from "./add_address.vue?vue&type=template&id=0ccdd8c0&scoped=true"
import script from "./add_address.vue?vue&type=script&lang=js"
export * from "./add_address.vue?vue&type=script&lang=js"

import "./add_address.vue?vue&type=style&index=0&id=0ccdd8c0&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ccdd8c0"]])

export default __exports__